import { Table } from 'antd';
import type { WorkDaysScheduleFieldProps } from '../model';
import { useWorkDaysScheduleField } from '../model';
import styles from './styles.module.scss';

export const WorkDaysScheduleField = (props: WorkDaysScheduleFieldProps) => {
  const {
    state: { columns, dataSource },
  } = useWorkDaysScheduleField(props);

  return (
    <div className={styles.root}>
      <Table
        className={styles.table}
        size="small"
        bordered={false}
        pagination={false}
        showHeader={false}
        rowKey="key"
        columns={columns}
        dataSource={dataSource}
      />
    </div>
  );
};
